import { render, staticRenderFns } from "./SellerDashboard.vue?vue&type=template&id=49c1e824"
import script from "./SellerDashboard.vue?vue&type=script&lang=js"
export * from "./SellerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports